import { motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const sections = [
  {
    title: "What Are Cookies?",
    content:
      "Cookies are small text files placed on your device when you visit a website. They help the site remember your preferences and understand how visitors use the site.",
  },
  {
    title: "How We Use Cookies",
    content:
      "Mosheli uses cookies to improve site performance, remember user preferences, and analyze website traffic. These insights help us refine content, improve user experience, and measure the effectiveness of our marketing.",
  },
  {
    title: "Types of Cookies We Use",
    content:
      "We use essential cookies for core functionality, analytics cookies to understand site usage, and preference cookies to remember your settings. We do not use cookies to sell your personal information.",
  },
  {
    title: "Third-Party Cookies",
    content:
      "Some third-party services embedded in our site, such as scheduling tools or analytics platforms, may set their own cookies. These providers are governed by their own policies.",
  },
  {
    title: "Managing Cookies",
    content:
      "You can manage cookies through your browser settings, including blocking or deleting cookies. If you disable certain cookies, some site features may not work as intended.",
  },
  {
    title: "Updates to This Policy",
    content:
      "We may update this Cookie Policy from time to time to reflect changes in technology or legal requirements. The effective date above will indicate the most recent revision.",
  },
  {
    title: "Contact Us",
    content:
      "If you have questions about our Cookie Policy, reach out at create@mosheli.com.",
  },
];

export default function CookiePolicy() {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-background">
        <section className="relative pt-32 pb-20 px-4 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-secondary/20 to-background" />
          <div className="container relative z-10 max-w-4xl mx-auto text-center">
            <motion.h1
              className="text-5xl md:text-6xl font-bold mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              Cookie <span className="text-gradient">Policy</span>
            </motion.h1>
            <motion.p
              className="text-xl text-muted-foreground mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
            >
              Effective date: January 25, 2026
            </motion.p>
            <motion.p
              className="text-base text-muted-foreground"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              This policy explains how cookies help us provide a better experience on mosheli.com.
            </motion.p>
          </div>
        </section>

        <section className="py-20 px-4">
          <div className="container max-w-4xl mx-auto space-y-10">
            {sections.map((section, index) => (
              <motion.div
                key={section.title}
                className="p-6 md:p-8 rounded-2xl bg-card border border-border"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
              >
                <h2 className="text-2xl font-semibold mb-3">{section.title}</h2>
                <p className="text-muted-foreground leading-relaxed">{section.content}</p>
              </motion.div>
            ))}
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}